import { render, staticRenderFns } from "./XpandReplication.vue?vue&type=template&id=7674852f&"
import script from "./XpandReplication.vue?vue&type=script&lang=js&"
export * from "./XpandReplication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7674852f')) {
      api.createRecord('7674852f', component.options)
    } else {
      api.reload('7674852f', component.options)
    }
    module.hot.accept("./XpandReplication.vue?vue&type=template&id=7674852f&", function () {
      api.rerender('7674852f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/serviceDetails/XpandReplication.vue"
export default component.exports